import type { VirtualChatMessageRow } from '../../types';
import { ChatMessageBubble } from '../chat-message-bubble';
import { ChatMessageLayout } from '../chat-message-layout';
import { ChatMessageFooter } from '../chat-message-layout/chat-message-footer';
import { ChatMessageHeader } from '../chat-message-layout/chat-message-header';
import { ChatMessageActions, useChatMessageActions } from './chat-message-actions';
import { useChatMessageRow } from './hooks';

type BubbleAppearance = {
  borderBottom?: boolean;
  borderTop?: boolean;
  marginBottom?: boolean;
};

type P = {
  row: VirtualChatMessageRow;
};

const getBubbleAppearance = (index: number, messagesCount: number): BubbleAppearance => {
  if (messagesCount === 1) {
    return {};
  }

  if (index === 0) {
    return { borderBottom: true, marginBottom: true };
  }

  if (index === messagesCount - 1) {
    return { borderTop: true };
  }

  return { borderBottom: true, borderTop: true, marginBottom: true };
};

const ChatMessageRow = ({ row }: P) => {
  const isFirstInGroup = row.group.index === 0;
  const { authorFullName, authorName, deliveryStatus, formattedTime } = useChatMessageRow({ row });
  const { menuItems } = useChatMessageActions({ direction: row.direction, message: row.message });
  const bubbleAppearance = getBubbleAppearance(row.group.index, row.group.length);

  return (
    <ChatMessageLayout row={row} tooltipTitle={authorFullName}>
      {isFirstInGroup ? (
        <ChatMessageHeader authorName={authorName} direction={row.direction} formattedTime={formattedTime} />
      ) : null}
      <ChatMessageActions direction={row.direction} items={menuItems}>
        <ChatMessageBubble
          direction={row.direction}
          message={row.message}
          tooltipTitle={formattedTime}
          {...bubbleAppearance}
        />
      </ChatMessageActions>
      {deliveryStatus ? <ChatMessageFooter deliveryStatus={deliveryStatus} /> : null}
    </ChatMessageLayout>
  );
};

export default ChatMessageRow;
